/**
 * @generated SignedSource<<5815cefb1befdcc6b6601b7b6fcd8f24>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DashboardSkillsAndTargetsByTargetGroupQuery$variables = {
  targetGroupId: string;
};
export type DashboardSkillsAndTargetsByTargetGroupQuery$data = {
  readonly skillsAndTargetsByTargetGroup: ReadonlyArray<{
    readonly skillInfo: {
      readonly code: string;
    };
    readonly targetSkills: ReadonlyArray<{
      readonly id: string;
      readonly target: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly targetSkillType: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
    }>;
  }>;
};
export type DashboardSkillsAndTargetsByTargetGroupQuery = {
  response: DashboardSkillsAndTargetsByTargetGroupQuery$data;
  variables: DashboardSkillsAndTargetsByTargetGroupQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "targetGroupId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "targetGroupId",
        "variableName": "targetGroupId"
      }
    ],
    "concreteType": "SkillTargetInfo",
    "kind": "LinkedField",
    "name": "skillsAndTargetsByTargetGroup",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BaseSkillInfo",
        "kind": "LinkedField",
        "name": "skillInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TargetSkillNode",
        "kind": "LinkedField",
        "name": "targetSkills",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TargetNode",
            "kind": "LinkedField",
            "name": "target",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TargetSkillTypeNode",
            "kind": "LinkedField",
            "name": "targetSkillType",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardSkillsAndTargetsByTargetGroupQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardSkillsAndTargetsByTargetGroupQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "32a9ba153f82524c875c3260d0e23203",
    "id": null,
    "metadata": {},
    "name": "DashboardSkillsAndTargetsByTargetGroupQuery",
    "operationKind": "query",
    "text": "query DashboardSkillsAndTargetsByTargetGroupQuery(\n  $targetGroupId: ID!\n) {\n  skillsAndTargetsByTargetGroup(targetGroupId: $targetGroupId) {\n    skillInfo {\n      code\n    }\n    targetSkills {\n      id\n      target {\n        id\n        name\n      }\n      targetSkillType {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "29a3314bfcda7fd835ec8d1be40be1d3";

export default node;
